import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CssBaseline } from '@material-ui/core';
import { createStore } from 'redux';
import { Provider } from "react-redux";
import uiReducer from './store/reducers/uiReducer';

const store = createStore(uiReducer);

ReactDOM.render(
	<React.StrictMode>
		<CssBaseline />
		<Provider store={store}>
		<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
